<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="" style="width:100%; padding: 20px">
                      <div v-if="isWufooLoading" class="text-center">
                        <page-loader></page-loader>
                      </div>
                      <div v-if="!isWufooLoading">
                        <iframe
                          id="JotFormIFrame-231234850054145"
                          title="Suggestion Form"
                          onload="window.parent.scrollTo(0,20)"
                          allowtransparency="true"
                          allowfullscreen="true"
                          :src="
                          'https://form.jotform.com/231234850054145?' +
                          prefillFields
                        "
                          frameborder="0"
                          style="min-width: 100%; height: 800px; border: none;"
                          scrolling="yes"
                        >
                        </iframe>
                        </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
import JotformEmbed from "@/components/shared/JotformEmbed"
export default {
  props: [],
  components: {PageLoader, JotformEmbed},
  data() {
    return {
      isModalShown: true,
      prefillFields: null,
      isWufooLoading: true,
      Account:{}
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
    GetAccountValues(){
      var _this = this;
      this.isAccountLoading = true;
      axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
      .then(function (response) {
          _this.Account = response.data.raw;
        _this.prefillFields =
          "peid=" +
          _this.Account.portalUserSalesforceId;
        _this.isWufooLoading = false;
          // _this.ShowWufoo(_this.Account.salesforceId);
      })
      .catch(function (error) {

      });
    },

  },
  created() {
    this.GetAccountValues();
  },
};
</script>



// WEBPACK FOOTER //
// SuggestForm.vue?f1aedaa0